
export default function useFeature(featureName) {
  return false
}